import { CompanyBlock, SHEET_CSS } from './QuotationSheet';

const yen = (n) => (n == null ? '' : '¥' + Number(n).toLocaleString('ja-JP', { timeZone: 'Asia/Tokyo' }));
const jd = (iso) => (iso ? String(iso).slice(0, 10).replaceAll('-', '/') : '');
const MIN_ROWS = 12;

// 月次まとめ請求書（締め請求）A4 print sheet — mkt_documents (doc_type: monthly_invoice) のスナップショットのみ描画
export default function MonthlyInvoiceSheet({ doc }) {
  if (!doc) return null;
  const s = doc.snapshot || {};
  const c = s.customer || {};
  const co = s.company || {};
  const [y, m] = (s.month || '').split('-');
  const rows = [...(s.rows || [])];
  while (rows.length < MIN_ROWS) rows.push(null);

  return (
    <>
      <style>{SHEET_CSS}</style>
      <div className="mkt-sheet" data-testid="mkt-monthly-invoice-sheet">
        <div className="meta">
          <div>請求番号: <b>{doc.doc_no}</b></div>
          <div>発行日: {jd(doc.issued_at)}</div>
        </div>
        <h1 className="title">御 請 求 書</h1>
        <div className="accent" />
        <div className="subtitle">{y}年{Number(m)}月度 締め分（{jd(s.period_from)} 〜 {jd(s.period_to)}）</div>

        <div className="parties">
          <div className="cust">
            <div className="cust-name">{c.name || ''}　{c.honorific || '御中'}</div>
            {(c.zip || c.address) && <div style={{ fontSize: '8.5pt', color: '#3f3f46' }}>{c.zip ? `〒${String(c.zip).replace('〒', '')}　` : ''}{c.address || ''}</div>}
            {c.contact && <div style={{ fontSize: '8.5pt', color: '#3f3f46' }}>ご担当: {c.contact} 様</div>}
            <div className="greet">下記の通りご請求申し上げます。</div>
            <div className="total-band">
              <span className="lbl">御請求金額 合計</span>
              <span className="val">{yen(s.total)}</span>
              <span className="tax-note">（税込）</span>
            </div>
            <div className="info">
              <div className="kv"><span className="k">締め日</span><span>{c.closing_day == null || c.closing_day === 99 ? '末日' : `${c.closing_day}日`}</span></div>
              {c.payment_terms && <div className="kv"><span className="k">お支払条件</span><span>{c.payment_terms}</span></div>}
            </div>
          </div>
          <CompanyBlock s={s} co={co} />
        </div>

        <div style={{ marginTop: '4mm' }}>
          <table className="lines">
            <colgroup>
              <col style={{ width: '22mm' }} /><col style={{ width: '26mm' }} />
              <col /><col style={{ width: '30mm' }} />
            </colgroup>
            <thead>
              <tr><th>売上日</th><th>受注番号</th><th>件名 ・ 摘要</th><th>金額（税抜）</th></tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i}>
                  <td className="ctr">{r ? jd(r.completed_at) : '\u00A0'}</td>
                  <td className="ctr"><span className="sku">{r ? r.order_no : ''}</span></td>
                  <td>{r ? <>{r.title || r.summary}{r.title && r.summary && <span className="sku">　{r.summary}</span>}</> : ''}</td>
                  <td className="r">{r ? yen(r.subtotal) : ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <table className="sum">
            <tbody>
              <tr><th>小計</th><td>{yen(s.subtotal)}</td></tr>
              <tr><th>消費税</th><td>{yen(s.tax)}</td></tr>
              <tr><th style={{ fontWeight: 700 }}>合計</th><td style={{ fontWeight: 700 }}>{yen(s.total)}</td></tr>
            </tbody>
          </table>
        </div>

        {co.bank && (
          <div className="box">
            <div className="box-lbl">お振込先</div>
            <div style={{ whiteSpace: 'pre-line' }}>{co.bank}</div>
          </div>
        )}
        <div className="box">
          <div className="box-lbl">備考</div>
          <div>{'\u00A0'}</div>
        </div>

        <div className="foot">
          <span>対象受注: {(s.rows || []).length}件　／　発行者: {doc.issued_by}</span>
        </div>
      </div>
    </>
  );
}
